<template>
<div class="tab-box">
  <div class="nav">
    <div class="left-tab" v-hidden>
      <div class="left-tab__icon" :style="leftStyle" @mouseover="changeLeftImg(true)" @mouseout="changeLeftImg(false)" @click="turnLeft"></div>
    </div>
    <div class="tabs">
      <ul class="tab-list" v-scrollX>
        <li class="tab-item" @click="changeIndexId(0)" @mouseout="hoverLabel=0" :class="{'hover-label-index':hoverLabel===-1&&indexIdC!==0, 'current-index':indexIdC===0}">
          <div class="item-info"><a class="item-link" :class="hoverLabel===-1&&indexIdC!==0?'is-home-active':'is-home'" id="home" @mouseover="hoverLabel=-1">首页</a></div>
        </li>
        <li v-for="item in showArray" :key="item.mid" class="tab-item" @click="changeIndexId(item.id)" @mouseover="hoverLabel=item.id" @mouseout="hoverLabel=0" :class="{'current':indexIdC===item.id, 'hover-label':hoverLabel===item.id&&indexIdC!==item.id}">
          <div class="item-info">
            <a class="item-link" :class="hoverLabel===item.id&&indexIdC!==item.id?'is-home-active':'is-home'" :id="item.id">{{item.name}}</a>
            <img v-show="indexIdC===item.id||hoverLabel===item.id" class="close-icon" :src="closeImg" alt="关闭" @click.stop="closeCurrentTab(item.id)"  @mouseover="changeCloseImg(true)" @mouseout="changeCloseImg(false)"/>
          </div>
        </li>
      </ul>
    </div>
    <div class="right-tab" v-hidden>
      <div class="right-tab__icon" :style="rightStyle" @mouseover="changeRightImg(true)" @mouseout="changeRightImg(false)" @click="turnRight"></div>
    </div>
  </div>
  <!-- 页签栏更多、全屏 -->
  <div class="nav-tabs__settings">
    <div class="fullscreen" @mouseover="changeFullscreenImg('over')" @mouseout="changeFullscreenImg('out')" @click="openFullScreen">
      <img class="fullscreen-icon" :src="fullscreenImg" alt="全屏">
    </div>
    <div class="more" @mouseover="showWindow(true)">
      <div class="ellipsis"><img class="more-icon" :src="moreImg" alt="操作" @mouseout="showWindow(false)"></div>
      <div :class="ifShowTabSettings ? 'tab-more' : 'tab-more hidden'" @mouseout="showWindow(false)">
        <div class="window-item" @click="closeCurrentTab(indexIdC)">关闭当前</div>
        <div class="window-item" @click="closeAllTabs">全部关闭</div>
        <div class="window-item" @click="closeOtherTabs(indexIdC)">除此之外全部关闭</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {hasClass, removeClass, addClass} from 'utils/util'
import {close, closeActive, more, moreActive, fullscreen, fullscreenActive, lefttab, lefttabActive, righttab, righttabActive} from '@/utils/imgUrl'
let len = 1
function getWidth () {
  let width = document.getElementsByClassName('tabs')[0].clientWidth
  let items = document.getElementsByClassName('tab-item')
  let itemsCurrentWidth = 0
  let itemsWidth = 0
  for (let i = 0; i < items.length; i++) {
    itemsWidth += items[i].clientWidth
  }
  for (let i = 0; i < items.length; i++) {
    itemsCurrentWidth += items[i].clientWidth
    if (hasClass(items[i], 'current')) {
      break
    }
  }
  return [width, itemsWidth, itemsCurrentWidth]
}
export default {
  data () {
    return {
      fullscreenImg: fullscreen,
      moreImg: more,
      hoverLabel: 0,
      ifShowTabSettings: false,
      rightStyle: 'background: url(' + righttab + ') no-repeat right / cover;',
      leftStyle: 'background: url(' + lefttab + ') no-repeat left / cover;',
      closeImg: close
    }
  },
  props: {
    showArray: {
      type: Array,
      default: () => []
    },
    indexIdC: {
      type: Number,
      default: 0
    }
  },
  methods: {
    openFullScreen () {
      this.$emit('openFullScreen')
    },
    closeCurrentTab (id) {
      this.$emit('closeIframe', id)
    },
    closeAllTabs () {
      this.$emit('closeAllTabs')
      this.$emit('update:indexIdC', 0)
    },
    closeOtherTabs (id) {
      this.$emit('closeOtherTabs', id)
    },
    changeFullscreenImg (cls) {
      // 改变全屏图标效果
      if (cls === 'out') {
        this.fullscreenImg = fullscreen
      } else if (cls === 'over') {
        this.fullscreenImg = fullscreenActive
      }
    },
    showWindow (cls) {
      // 滑过改变“更多”图标效果并展示关闭功能
      if (cls === true) {
        this.moreImg = moreActive
        this.ifShowTabSettings = true
      } else if (cls === false) {
        this.moreImg = more
        this.ifShowTabSettings = false
      }
    },
    changeLeftImg (op) {
      if (op === true) {
        this.leftStyle = 'background: url(' + lefttabActive + ') no-repeat left / cover;'
      } else {
        this.leftStyle = 'background: url(' + lefttab + ') no-repeat left / cover;'
      }
    },
    changeRightImg (op) {
      if (op === true) {
        this.rightStyle = 'background: url(' + righttabActive + ') no-repeat right / cover;'
      } else {
        this.rightStyle = 'background: url(' + righttab + ') no-repeat right / cover;'
      }
    },
    changeCloseImg (op) {
      if (op === true) {
        this.closeImg = closeActive
      } else {
        this.closeImg = close
      }
    },
    changeIndexId (id) {
      console.log(id);
      this.$emit('update:indexIdC', id)
    },
    turnLeft () {
      // 左滑功能
      let tabList = document.getElementsByClassName('tab-list')[0]
      let tx = 0
      if (tabList.style.webkitTransform) {
        tx = tabList.style.webkitTransform.split('translateX(')[1].split('px)')[0]
      } else {
        tx = tabList.style.transform.split('translateX(')[1].split('px)')[0]
      }
      let [width, itemsWidth, itemsCurrentWidth] = getWidth()
      if (tx > -50) {
        tx = 0
      } else {
        tx = parseInt(tx) + 50
      }
      tabList.style['transform'] = `translateX(${tx}px)`
    },
    turnRight () {
      // 右滑功能
      let tabList = document.getElementsByClassName('tab-list')[0]
      let tx = 0
      if (tabList.style.webkitTransform) {
        tx = tabList.style.webkitTransform.split('translateX(')[1].split('px)')[0]
      } else {
        tx = tabList.style.transform.split('translateX(')[1].split('px)')[0]
      }
      let [width, itemsWidth, itemsCurrentWidth] = getWidth()
      if (width + (-tx) >= itemsWidth - 50) {
        tx = -(itemsWidth - width)
      } else {
        tx = parseInt(tx) - 50
      }
      tabList.style['transform'] = `translateX(${tx}px)`
    }
  },
  directives: {
    hidden: {
      inserted (el) {
        addClass(el, 'hidden')
      }
    },
    scrollX: {
      componentUpdated (el) {
        let tabList = document.getElementsByClassName('tab-list')[0]
        let left = document.getElementsByClassName('left-tab')[0]
        let right = document.getElementsByClassName('right-tab')[0]
        let items = document.getElementsByClassName('tab-item')
        let currentItem = document.getElementsByClassName('current')
        let [width, itemsWidth, itemsCurrentWidth] = getWidth()
        if (itemsWidth >= width) {
          removeClass(document.getElementsByClassName('left-tab')[0], 'hidden')
          removeClass(document.getElementsByClassName('right-tab')[0], 'hidden')
        } else {
          addClass(document.getElementsByClassName('left-tab')[0], 'hidden')
          addClass(document.getElementsByClassName('right-tab')[0], 'hidden')
          tabList.style['transform'] = `translateX(0px)`
        }
        if (len < items.length) {
          if (!hasClass(left, 'hidden') && !hasClass(right, 'hidden')) {
            tabList.style['transform'] = `translateX(${-(itemsCurrentWidth - width)}px)`
          }
        }
        len = items.length
      }
    }
  }
}
</script>

<style lang="less">
@import '~assets/style/variable.less';
.tab-box {
width: 100%;
height: 36px;
background: #EBEBEB;
display: flex;
}
.hover-label-index {
  color: @color-theme !important;
  background: @color-bg-active !important;
  padding: 0 21px;
}
.hover-label {
  color: @color-theme !important;
  background: @color-bg-active !important;
  padding-left: 12px !important;
  padding-right: 8px !important;
}
.nav {
flex: 1;
overflow: hidden;
display: flex;
}
.nav-tabs__settings{
float: right;
height: 100%;
}
.tab-item {
float: left;
display: block;
padding: 0 21px;
cursor: pointer;
line-height: 36px;
}
.tab-item__hover {
background: #EFF2F7;
color: #20A0FF;
}
.tabs {
float: left;
flex: 1;
overflow: hidden;
position: relative;
}
.tab-list {
height: 100%;
width:5000px;
display:block;
margin:auto;
padding:0;
border-collapse:collapse;
border-collapse:separate;
white-space:nowrap;
overflow-x:auto;
overflow-y:hidden;
}
.left-tab {
width: 24px;
height: 36px;
background: #FFFFFF;
box-shadow: 2px 0 4px 0 #EBEBEB;
cursor: pointer;
z-index: 9;
}
.right-tab {
right: 88px;
width: 24px;
height: 36px;
background: #FFFFFF;
box-shadow: -2px 0 4px 0 #EBEBEB;
cursor: pointer;
z-index: 9;
}
.left-tab__icon, .right-tab__icon {
width: 100%;
height: 100%;
}
.tab-item {
float: left;
display: block;
cursor: pointer;
line-height: 36px;
}
.tab-item__hover {
background: #EFF2F7;
color: #20A0FF;
}
.current-index {
color: #20A0FF;
background: #FFFFFF;
.is-home {
color: #20A0FF !important;
}
}
.current {
color: #20A0FF;
background: #FFFFFF;
padding-left: 12px !important;
padding-right: 8px !important;
}
.current a,.current span {
color: #20A0FF !important;
}
.item-info {
height: 100%;
box-sizing: border-box;
display: flex;
}
.is-home {
min-width: 40px;
text-align: center;
}
.is-home {
min-width: 40px;
text-align: center;
}
.is-home-active {
min-width: 40px;
text-align: center;
color: @color-theme !important;
}
.is-closed {
padding: 0 21px;
}
.not-closed {
padding-left: 12px;
padding-right: 8px;
}
.is-closed:hover {
padding-left: 12px;
padding-right: 8px;
}
.item-link {
color: #999999;
font-size: 14px;
letter-spacing: 0;
display: inline-block;
}
.item-link__hover {
color: #20A0FF;
}
.ellipsis {
width: 100%;
height: 100%;
}
.ellipsis:hover {
width: 100%;
height: 100%;
background: #EEF7FF;
}
.fullscreen {
cursor: pointer;
float: left;
width: 36px;
height: 100%;
}
.fullscreen:hover {
background: #EEF7FF;
}
.fullscreen-icon {
width: 100%;
height: 100%;
}
.more {
cursor: pointer;
float: right;
width: 36px;
height: 100%;
box-sizing: border-box;
}
.more-icon {
width: 100%;
height: 100%;
}
.tab-more {
position: absolute;
width: 136px;
top: 36px;
right: 0;
z-index: 10;
background: #FFFFFF;
border: 1px solid #EEEEEE;
}
.hidden {
display: none;
}
.window-item {
line-height: 42px;
font-size: 14px;
color: #666666;
text-indent: 8px;
cursor: pointer;
}
.window-item:hover {
color: #1FA0FF;
background: #EEF7FF;
}
.close-icon {
float: right;
margin: 8px auto;
vertical-align: middle;
width: 22px;
height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/tabBox.vue